import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f4f89bc&scoped=true&"
import script from "./aggregationSearch.js?vue&type=script&lang=js&"
export * from "./aggregationSearch.js?vue&type=script&lang=js&"
import style0 from "./aggregationSearch.styl?vue&type=style&index=0&id=0f4f89bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f89bc",
  null
  
)

export default component.exports